import { memo } from "react";
import PropTypes from "prop-types";
import { Amount } from "app/components/ui/Amount/Amount";
import { FormattedMessage } from "react-intl";
import Popover from "app/components/ui/Popover/Popover";
import "./SearchEngineCreditBanner.scss";
import { MoneyBagFilledIcon } from "app/icons/finance";

const SearchEngineCreditBanner = ({ totalCredit }) => {
	if (!totalCredit) {
		return false;
	}
	return (
		<div className="search-engine-credit-banner" data-testid="search-engine-credit-banner">
			<div className="search-engine-credit-banner__content">
				<div className="search-engine-credit-banner__icon">
					<MoneyBagFilledIcon width={12} height={15} />
				</div>
				<span className="search-engine-credit-banner__text">
					<FormattedMessage
						id="search.engine.credit.banner.text"
						values={{
							amount: (
								<Amount
									value={totalCredit}
									size="small"
									className="search-engine-credit-banner__amount"
								/>
							),
						}}
					/>
				</span>
				<Popover iconClassName="search-engine-credit-banner__cgu-icon">
					<div
						className="search-engine-credit-banner__cgu"
						data-testid="search-engine-credit-icon"
					>
						<div className="search-engine-credit-banner__credit-cgu-title">
							<FormattedMessage id="mycoupons.credit.banner.info.title" />
						</div>
						<div className="search-engine-credit-banner__credit-cgu-description">
							<FormattedMessage id="mycoupons.credit.banner.info.description" />
						</div>
					</div>
				</Popover>
			</div>
		</div>
	);
};

SearchEngineCreditBanner.propTypes = {
	totalCredit: PropTypes.any,
};

export default memo(SearchEngineCreditBanner);
